/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect fill="#363135" x={59} y={84} width={394} height={428} rx={20} />
      <rect fill="#FFF" x={101} y={123} width={310} height={349} rx={9} />
      <rect fill="#363135" x={313} y={193} width={34} height={210} rx={17} />
      <rect fill="#363135" x={239} y={193} width={34} height={210} rx={17} />
      <rect fill="#363135" x={165} y={193} width={34} height={210} rx={17} />
      <rect fill="#363135" y={84} width={512} height={39} rx={19.5} />
      <rect fill="#363135" x={145} width={222} height={123} rx={20} />
      <path fill="#FFF" d="M190.129 40H322v44H190z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconTrash = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconTrash.defaultProps = {
  theme,
};
IconTrash.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconTrash.displayName = 'IconTrash';
export { IconTrash };
